export class ProfessionsCardModel {
  id: string = ''
  name: string = ''
  image: string = ''
  slug? = ''
  icon? = ''
}

export interface BaseDirection {
  name: string
  slug: string
}
